import styled from "styled-components";
import { colors, easing, fadeUp, layout, zoomOut } from "../../../theme";
import { Eyebrow } from "../Typography";

export const HeaderContainer = styled.header`
  position: relative;
  overflow: hidden;
  background-color: ${colors.secondary};
  padding: calc(${layout.navHeight} + clamp(3rem, 7vw, 5.5rem)) ${layout.gutter}
    clamp(3rem, 6vw, 4.5rem);
`;

export const HeaderBackground = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: ${zoomOut} 2.4s ${easing.out} both;
`;

export const HeaderOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(
      ellipse at 15% 110%,
      rgba(255, 195, 11, 0.28),
      transparent 55%
    ),
    linear-gradient(
      180deg,
      rgba(28, 28, 28, 0.88) 0%,
      rgba(28, 28, 28, 0.72) 55%,
      rgba(28, 28, 28, 0.86) 100%
    );
`;

export const HeaderContent = styled.div`
  position: relative;
  max-width: ${layout.maxWidth};
  margin: 0 auto;
`;

export const HeaderEyebrow = styled(Eyebrow)`
  animation: ${fadeUp} 0.8s ${easing.out} 0.1s both;
`;

export const HeaderTitle = styled.h1`
  margin-top: 1rem;
  font-size: clamp(2.5rem, 6vw, 4.25rem);
  color: ${colors.primary};
  animation: ${fadeUp} 0.8s ${easing.out} 0.2s both;
`;

export const HeaderSubtitle = styled.p`
  margin-top: 1rem;
  max-width: 40rem;
  font-size: clamp(1.05rem, 1.6vw, 1.2rem);
  color: rgba(255, 255, 234, 0.85);
  animation: ${fadeUp} 0.8s ${easing.out} 0.32s both;
`;
